import { useMutation } from '@tanstack/react-query';
import { getCallDetails as getCallDetailsService } from '../../api/AgentCenterAPI';

export const useGetCallDetails = () => {
    const {
        mutateAsync: getCallDetails,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: getCallDetailsService,
    });

    return { getCallDetails, isPending, ...rest };
};
